import axios from '@/services/api'

/**
 * @returns {Promise<Object>}
 */
export const fetchTags = ({ page = 1, search = '' }) => {
	const params = new URLSearchParams({ page })
	if (search) params.append('search', search)

	return axios.get(`/api/tags?${params.toString()}`)
}

/**
 * @returns {Promise<Object>}
 */
export const fetchPopularTags = (query) => {
	const url = '/api/tags/popular'
	return axios.get(url, { params: query })
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addTag = (data) => {
	const url = `/api/tags`
	return axios.post(url, data)
}

/**
 * @param {Number} id tag ID
 * @returns {Promise<Object>}
 */
export const deleteTag = (id) => {
	const url = `/api/tags/${id}`
	return axios.delete(url)
}
